<template>
    <v-row>
    </v-row>
</template>

<script>
export default {
    name: 'TicketAdd',

}
</script>

<style>

</style>